var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.preview}},[_vm._v("预览")]),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.addCustom}},[_vm._v("添加")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }